export default __webpack_public_path__ + "static/Javahouse-1beab6396b4bab9a13ef6669a9eae1a9.png";